module.exports = __webpack_public_path__ + "img/deyang.b5cce1e8.jpg";